import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {BadgeModule} from 'primeng/badge';

@Component({
  selector: 'app-consulta-leilao-complementar',
  templateUrl: './consulta-leilao-complementar.component.html',
  styleUrls: ['./consulta-leilao-complementar.component.scss']
})
export class ConsultaLeilaoComplementarComponent implements OnInit {

  pontuacaoScore = 1;
  pontuacaoAceitacao = 1;
  pontuacaoFipe = 1;
  pontuacaoVistoria = 1;
  condicaoVeiculo;
  condicaoVeiculoDescricao;
  aceitacao;

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'danger';

  @Input() token = '';

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.setStatus();
    this.preencherPontuacao();
    this.pegarCondicaoVeiculoNumero();
    this.pegarAceitacao();

  }

  pegarAceitacao(){
    if(this.consulta){
      if(this.consulta.aceitacaoVeiculo != null || this.consulta.aceitacaoVeiculo != ""){
        let aceitacaoString = this.consulta.aceitacaoVeiculo;
        aceitacaoString = aceitacaoString?.replace(",", ".");
        aceitacaoString = aceitacaoString?.substring(0, aceitacaoString.length - 1);
        this.aceitacao = Number(aceitacaoString);
      }
    }
  }

  pegarCondicaoVeiculoNumero(){
    if (this.consulta) {
      if (this.consulta.lista && this.consulta.lista.length > 0) {
        for (let i = 0; i < this.consulta.lista.length; i++) {
          let str = this.consulta.lista[i]['score'];
          let resultadoString = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

          if(resultadoString == 'APARENTEMENTE INTEIRO'){
            this.condicaoVeiculo = 1;
            this.condicaoVeiculoDescricao = 'APARENTEMENTE INTEIRO'
          }
          if(resultadoString == 'PEQUENOS DANOS'){
            this.condicaoVeiculo = 2;
            this.condicaoVeiculoDescricao = 'PEQUENOS DANOS';
          }
          if(resultadoString == 'MEDIOS DANOS'){
            this.condicaoVeiculo = 3;
            this.condicaoVeiculoDescricao = 'MÉDIOS DANOS'
          }
          if(resultadoString == 'GRANDES DANOS / SUCATA / ALAGADO / ENCHENTE'){
            this.condicaoVeiculo = 4;
            this.condicaoVeiculoDescricao = 'GRANDES DANOS'
          }
        }

      }
    }
  }



  preencherPontuacao() {
    if (this.consulta) {
      if (this.consulta.lista && this.consulta.lista.length > 0) {
        //score novo
        for (let i = 0; i < this.consulta.lista.length; i++) {

          // Pega todos os Scores e passa para a variavel str ..
          let str = this.consulta.lista[i]['score'];
          // Retira os acentos e cedilhas do valor da string str usando expressão regular ...
          let resultadoString = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

          if (resultadoString == "APARENTEMENTE INTEIRO" || resultadoString == "PEQUENOS DANOS" && this.pontuacaoScore < 2) {
            this.pontuacaoScore = 2;
          }
          if (resultadoString == "MEDIOS DANOS" && this.pontuacaoScore < 5) {
            this.pontuacaoScore = 5;
          }
          if (resultadoString == "GRANDES DANOS / SUCATA / ALAGADO / ENCHENTE" && this.pontuacaoScore < 9) {
            this.pontuacaoScore = 9;
          }
          //score antigo
          if (resultadoString == "Sem dano - Financeira/Banco + sem dano/Seguradora + sem dano" && this.pontuacaoScore < 2) {
            this.pontuacaoScore = 2;
          }
          if (resultadoString == "Judicial - Financeira - Bancos - Outros" && this.pontuacaoScore < 4) {
            this.pontuacaoScore = 4;
          }
          if (resultadoString == "Sem Analise" && this.pontuacaoScore < 6) {
            this.pontuacaoScore = 6;
          }
          if (resultadoString == "Seguradoras - Detrans - Ciretrans" && this.pontuacaoScore < 8) {
            this.pontuacaoScore = 8;
          }
          if (resultadoString == "Danificado - Financeira/Banco + Danificado - Seguradora + Danificado" && this.pontuacaoScore < 10) {
            this.pontuacaoScore = 10;
          }
        }
      }

      if (this.consulta.aceitacaoVeiculo != null && this.consulta.aceitacaoVeiculo != "") {
        let ponto = this.consulta.aceitacaoVeiculo.substr(0, (this.consulta.aceitacaoVeiculo.length - 1));
        this.pontuacaoAceitacao = Math.floor(((100 - (ponto))/10)) + 1;
      }
      if (this.consulta.percentagemRef != null && this.consulta.percentagemRef != "") {
        let ponto = this.consulta.percentagemRef.substr(0, (this.consulta.percentagemRef.length - 1));
        this.pontuacaoFipe = Math.floor(((100-(ponto))/10))+1;
      }
      if (this.consulta.exigVistEspec == "MAIOR PROBABILIDADE") {

        this.pontuacaoVistoria = 9;
      }
      if (this.consulta.exigVistEspec == "MENOR PROBABILIDADE") {

        this.pontuacaoVistoria = 2;
      }

    }
  }

  setStatus() {
    if ((this.codigoControle == "SEMREGISTRO_OK") || (this.codigoControle == "SEMREGISTRO_NAOCOBRAR") || (this.consulta.lista && this.consulta.lista.length < 1)) {
      this.status = "success";
    }
  }
}



